// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"d19b5301","502":"4a43b3a5","573":"39da84c0","653":"d696a370","835":"24706cc1"}[chunkId] + ".chunk.css";
};